export default "__VITE_ASSET__b52b719c__"